import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth/auth.slice";
import vendorSearchReducer from "./vendor.search.slice"
export const store = configureStore({
  reducer: {
    auth: authReducer,
    searchVendor:vendorSearchReducer
  },
});

export default store;
